var parent = require('../../es/object/set-prototype-of');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/object/set-prototype-of.js
// module id = 4331
// module chunks = 25